import { Calendar } from "../models/basic/template";
import { AbstractService } from "./abstract-service";
import { URLS } from "./app-urls";

export class NpiCalendarService extends AbstractService<Calendar> {

    constructor() {
        super(URLS.NPI_CALENDAR);
    }
}
